export function ProblemSection() {
  return (
    <section className="landing-band" id="problem">
      <div className="landing-wrap landing-section">
        <div className="section-head">
          <h2 className="section-title">A number you can&apos;t defend isn&apos;t an answer.</h2>
          <p className="section-sub">
            Generic tools hand you a result with no paper trail: assumptions buried in a
            spreadsheet, clauses that quietly went stale, an AI that reasons differently every
            run. When the plan check or the lawsuit comes, you&apos;re defending a black box.
          </p>
        </div>

        <div className="compare-grid">
          <div className="compare-col compare-col--without">
            <div className="compare-head">The black box</div>
            <ul>
              <li>Numbers with no cited basis, so you re-derive them to trust them</li>
              <li>Assumptions hidden in a spreadsheet only one person understands</li>
              <li>Code editions that silently fall out of date</li>
              <li>An AI that designs, then asks you to take its word for it</li>
            </ul>
          </div>
          <div className="compare-col compare-col--with">
            <div className="compare-head">With Firmark</div>
            <ul>
              <li>Every value tied to its governing clause and edition</li>
              <li>Your standards set once, applied openly, logged on every run</li>
              <li>Editions tracked as a code-currency promise</li>
              <li>An AI that supervises, asks, and learns. It never stamps.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
